import { EventBuilder } from './EventBuilder';
import Core from '../Core/Core';

export interface IEntryPointCrossPromoParams {
    epPromoSource: string;
}

export class CpParamBuilder extends EventBuilder {
    constructor() {
        super();
    }

    public setAllAdParamsFromGame() {}

    public getParams<T>(): IEntryPointCrossPromoParams {
        const entryData = Core.sdk.messages.getEntryPointData() || {};
        // @ts-ignore
        const payload = entryData.payload || {};
        const source = payload.originGameId || 'none';
        return {
            epPromoSource: source,
        };
    }

    public setParams(keys: Map<string, unknown>): void {
        keys.forEach((value, key) => {});
    }
}
